import Helpers from '../modules/Helpers'
import StarRating from '../modules/StarRating'
import XHRPromise from 'xhr-promise'

const modal = document.getElementById('guideReviewModal')

if (modal !== null) {

    const titleEl = modal.getElementsByTagName('h3')[0]
    const form = modal.getElementsByTagName('form')[0]
    const successView = modal.getElementsByClassName('modal-guide-review__success')
    const errorView = modal.getElementsByClassName('modal-guide-review__error')

    // on button click, initialise modal
    new Helpers(document.getElementsByClassName('property-explore__review-cta')).eventListener((e) => {
        const el = e.target

        // get attraction info from button
        const attractionId = el.getAttribute('data-id')
        const attractionName = el.getAttribute('data-name')
        
        // reset view
        form.setAttribute('aria-hidden', false)
        new Helpers(successView).setAttributes({ 'aria-hidden': true })
        new Helpers(errorView).setAttributes({ 'aria-hidden': true })

        // set the title and the id
        titleEl.innerText = `Review ${attractionName}`
        form.attractionId.value = attractionId

        // reset form values
        form.reviewTitle.value = ''
        form.reviewDescription.value = ''
        form.reviewAnonymous.checked = false
        new StarRating(modal.getElementsByClassName('star-rating')[0]).clear()
        
    })


    // on submit of modal form, handle with ajax
    new Helpers(form).eventListener((e) => {
        e.preventDefault()
        const xhr = new XHRPromise()

        xhr.send({
            method: 'POST',
            url: "/my-classic/Ajax.aspx",
            data: `type=submitreview&AttractionId=${form.attractionId.value}&Title=${form.reviewTitle.value}&Description=${form.reviewDescription.value}&StarRating=${form.reviewRating.value}&Anonymous=${form.reviewAnonymous.checked ? 1 : 0}`
        })
            .then((response) => {
                if (response.status !== 200) {
                    throw new Error('submission failed')
                }
                //show success dialog, with timeout to close modal
                form.setAttribute('aria-hidden', true)
                new Helpers(successView).setAttributes({ 'aria-hidden': false })
            })
            .catch((e) => {
                // show failure dialog
                form.setAttribute('aria-hidden', true)
                new Helpers(errorView).setAttributes({ 'aria-hidden': false })
            })
    }, 'submit')

}